import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  option: {
    width: 110,
    height: 28,
    borderRadius: 4,
    cursor: 'pointer',
    textAlign: 'center',
    paddingTop: theme.spacing(0.5),
    border: '1px solid #6F2C8D10',
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  activeOption: {
    color: theme.palette.white,
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    fontWeight: 500,
  },
})

const SelectPeopleType = ({ activeFilter, classes, onChange }) => {
  return (
    <div className={classes.root}>
      <div
        onClick={() => onChange(null)}
        className={classNames(
          classes.option,
          !activeFilter[0].value && classes.activeOption
        )}>
        <Typography className={classes.title}>All</Typography>
      </div>
      <div
        onClick={() => onChange('CONTRIBUTOR')}
        className={classNames(
          classes.option,
          activeFilter[0].value === 'CONTRIBUTOR' && classes.activeOption
        )}>
        <Typography className={classes.title}>Contributors</Typography>
      </div>
      <div
        onClick={() => onChange('ADMIN')}
        className={classNames(
          classes.option,
          activeFilter[0].value === 'ADMIN' && classes.activeOption
        )}>
        <Typography className={classes.title}>Admin</Typography>
      </div>
    </div>
  )
}

SelectPeopleType.propTypes = {
  onChange: PropTypes.func,
  classes: PropTypes.object,
  activeFilter: PropTypes.array,
}

export default withStyles(styles)(SelectPeopleType)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleOverview/SelectPeopleType.js